import { createSelector } from 'reselect';

import calculateTotalsForOrder from '../utils/ordering/calculateTotalsForOrder';

import getStagedPurchasesTotals, {
  $getStagedPurchasesTotals,
} from './getStagedPurchasesTotals';
import getSelectedOffer, { $getSelectedOffer } from './getSelectedOffer';
import getSurcharges, { $getSurcharges } from './getSurcharges';
import getRewardsAccrualRate from './getRewardsAccrualRate';
import getStagedPurchases, { $getStagedPurchases } from './getStagedPurchases';
import { getCouponOrderingMethod, getChoiceOrderingMethod } from './config';
import getCouponMinimumSpendingInclusive from './getCouponMinimumSpendingInclusive';

const get = (
  purchaseTotals: StagedPurchasesTotals,
  offer: Offer | undefined,
  offerMinSpendInclusive: boolean,
  surcharges: Surcharge[],
  rewardsAccrualRate: number,
  purchasedItems: any[],
  couponOrderingMethod: any,
  choiceOrderingMethod: any,
): OrderTotals | undefined => {
  //@ts-ignore
  return calculateTotalsForOrder(
    purchaseTotals,
    offer,
    offerMinSpendInclusive,
    surcharges,
    rewardsAccrualRate,
    purchasedItems,
    couponOrderingMethod,
    choiceOrderingMethod,
  );
};

export default createSelector(
  [
    getStagedPurchasesTotals,
    getSelectedOffer,
    getCouponMinimumSpendingInclusive,
    getSurcharges,
    getRewardsAccrualRate,
    getStagedPurchases,
    getCouponOrderingMethod,
    getChoiceOrderingMethod,
  ],
  get,
);

export const $getOrderTotals = createSelector(
  [
    $getStagedPurchasesTotals,
    $getSelectedOffer,
    getCouponMinimumSpendingInclusive,
    $getSurcharges,
    getRewardsAccrualRate,
    $getStagedPurchases,
    getCouponOrderingMethod,
    getChoiceOrderingMethod,
  ],
  get,
);
